import { defineStore } from "pinia";
import Crud from "@/store/NewsFeed/crud";
import axios from "axios";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useLK } from "@/controllerLK/LKstore.js";
import {useNotificationsStore} from "@/store/notifications";
import { t } from "@/controllerLK/AvalLocalization";
import { useBlockStore } from "@/store/NewsFeed/blocks";
import {addMissingElements} from "@/functions/basic";

const crud = new Crud(
    process.env.VUE_APP_BASE_API + "Rubrics",
    "id",
    "",
    {}
);

const todayDate = new Date();
const sevenDayBefore = Date.parse(
    new Date(todayDate.setTime(todayDate.getTime() - (6 * 24 * 60 * 60 * 1000))).toISOString().split("T")[0]) / 1000;

const today = () => Date.parse(new Date()) / 1000;

let controller;
export const useNewsFeedStore = defineStore({
  id: "newsFeed",
  state: () => ({
    ...crud.state,
    currentNews: null,
    currentPage: 0,
    offset: 0,
    take: 20,
    currentImportance: [],
    isLastNews: false,
    isMarked: false,
    dateFrom: sevenDayBefore,
    dateTo: today(),
    favoriteVisible: false,
    abort: false,
    lastSearchedValue: null,
    searchValue: "",
    searchValueList: [],
    deleteCardList: [],
    totalCount: 1,
    pointer: false,
    facetParams: null,
    initialFacetObjects: {
      persons: [],
      locations: [],
      organisations: [],
    },
    onFilterTags: [],
    emptyNews: false,
    popupCardRubrics: false,
    popupCardTags: false,
    filterRegion: {
      title: "region",
      inputValue: "",
      list: [],
      filterList: [],
      nameList: [],
      condition: false
    },
    filterImportance: {
      title: "importance",
      list: []
    },
    filterSentiment: {
      title: "sentiment",
      list: []
    },
    filterCategories: {
      title: "categories",
      list: [],
      filterList: []
    },
    filterTags: {
      title: "tags",
      inputValue: "",
      list: [],
      listID: [],
      condition: true
    },
    filterPoliticalAffiliation: {
      title: "political",
      inputValue: "",
      value: "not_chosen",
      condition: true
    },
    filterObject: {
      title: "object",
      inputValue: "",
      list: [],
      listID: {
        persons: [],
        locations: [],
        organisations: []
      },
      condition: true
    },
    filterPersons: {
      title: "persons",
      inputValue: "",
      list: [],
      listID: [],
      condition: true
    },
    filterOrganisations: {
      title: "organisations",
      inputValue: "",
      list: [],
      listID: [],
      condition: true
    },

    downloadOn: false,
    downloadList: [],
    projectCities: [],
    useSemSearch: false
  }),
  getters: {
    ...crud.getters,
    getFiltredItems(state) {
      if (!state.items?.length) return;
      if (state.currentImportance === 0) {
        return state.items;
      }
      return (state.items || []).filter(
          (el) => el.importance === state.currentImportance
      );
    },
  },
  actions: {
    ...crud.actions,
    async translateNewsText(title, text, id) {
      try {
        const result = await axios.post("/translator/api/v1/translate", {
          id: id.toString(),
          title: title,
          text: text,
          to_language: "ru"
        });

        this.currentNews.is_translated = true;
        return {
          title: result.data.title,
          raw_text: result.data.text
        };
      } catch (e) {
        console.log(e);
        this.currentNews.is_translated = false;
        return text;
      }
    },
    async getNews() {
      if (this.favoriteVisible) {
        await this.getFavorite();
      } else {
        this.offset = 0;
        await this.getRubricNews();
      }
    },

    async getRubricNews() {
      if (controller) {
        controller.abort();
        this.loading = true;
      }

      this.loading = true;
      this.emptyNews = false;
      this.favoriteVisible = false;
      this.currentNews = null;
      this.offset = this.currentPage * this.take;

      // Устанавливаем минимальное значение 20 переходя из проекта, где меньше 20 новостей (задача 1791)
      if (this.take < 20) this.take = 20;
      try {
        this.loading = true;
        // this.items = []
        const { data } = await this.getDataForNews();
        this.totalCount = data.total_count;
        this.take = data.total_count < 20 ? data.total_count : this.take; // Задача 1791

        this.facetParams = data;

        // Сохраняем объекты фасета для persons
        if (this.initialFacetObjects.persons.length === 0) {
          this.initialFacetObjects.persons = data.persons;
        } else if (this.initialFacetObjects.persons.length > 0) {
          addMissingElements(this.initialFacetObjects.persons, data.persons);
        }

        // Сохраняем объекты фасета для locations
        if (this.initialFacetObjects.locations.length === 0) {
          this.initialFacetObjects.locations = data.locations;
        } else if (this.initialFacetObjects.locations.length > 0) {
          addMissingElements(this.initialFacetObjects.locations, data.locations);
        }

        // Сохраняем объекты фасета для organisations
        if (this.initialFacetObjects.organisations.length === 0) {
          this.initialFacetObjects.organisations = data.organisations;
        } else if (this.initialFacetObjects.organisations.length > 0) {
          addMissingElements(this.initialFacetObjects.organisations, data.organisations);
        }

        // Сохраняем города фасета
        if (this.filterRegion.list?.length === 0) {
          this.filterRegion.list = data.cities;
        } else {
          addMissingElements(this.filterRegion.list, data.cities, "id");
        }

        this.items = data.cards;

        if (this.filterCategories.list.length === 0) {
          await this.getCategoriesList();
        }

        this.currentNews = this.items[0];
        // this.facetParams = data
        this.onFilterTags = data.tags;
        if (!this.facetParams?.cards?.length) {
          this.emptyNews = true;
          this.loading = false;
        }
        if (!this.items?.length) {
          this.emptyNews = true;
        } else {
          this.loading = false;
          this.emptyNews = false;
        }
      } catch (err) {
        this.setError(err);
      } finally {
        this.loading = false;
      }
    },

    async getCategoriesList() {
      await axios.get(process.env.VUE_APP_BASE_API + "Categories/list").then((res) => {
        this.filterCategories.list = res.data ? res.data : [];
      });
    },

    async getCities() {
      const LKstore = useLK();
      this.filterRegion.list = [];
      await axios.get(process.env.VUE_APP_BASE_API + `Cities/${LKstore.project.id}`).then(res => {
        this.projectCities = res.data;
      });
    },

    clearNewsFeed() {
      this.currentPage = 0;
      this.totalCount = 0;
      this.isLastNews = false;
      this.items = [];
      this.currentNews = null;
      this.offset = 0;
    },

    clearFacet() {
      this.filterTags.condition = true;
      this.filterObject.condition = true;
      this.filterRegion.condition = true;
      this.filterRegion.list = [];
      this.filterRegion.inputValue = "";
      this.filterRegion.filterList = [];

      this.filterImportance.list = [];

      this.filterSentiment.list = [];

      this.filterCategories.list = [];
      this.filterCategories.filterList = [];

      this.filterTags.list = [];
      this.filterTags.listID = [];
      this.filterTags.inputValue = "";

      this.filterObject.list = [];
      this.filterObject.listID.persons = [];
      this.filterObject.listID.locations = [];
      this.filterObject.listID.organisations = [];
      this.filterObject.inputValue = "";

      this.dateFrom = sevenDayBefore;
      this.dateTo = today();
      this.facetParams = null;
      this.initialFacetObjects = {
        persons: [],
        locations: [],
        organisations: [],
      };
    },

    async updateFacet() {
      await this.getDataForNews().then(res => {
        this.facetParams = res.data;
      });
    },

    async getDataForNews() {
      controller = new AbortController();
      const blockStore = useBlockStore();
      const rubricsStore = useRubricsStore();
      const rubricIDs = rubricsStore.chosenRubrics;
      const themesIds = blockStore.chosenThemes;
      const mainURL = process.env.VUE_APP_BASE_API +"cards";
      const url = `${mainURL}?offset=${this.offset}&take=${this.take}`;

      return await axios.post(url, {
            "q": this.searchValue,
            "project_id": useLK().project.id,
            "rubrics": rubricIDs,
            "blocks": themesIds,
            "categories": this.filterCategories.filterList,
            "cities": this.filterRegion.filterList,
            "and_for_cities": this.filterRegion.condition,
            "importance": this.filterImportance.list,
            "sentiments": this.filterSentiment.list,
            "tags": this.filterTags.listID,
            "and_for_tags": this.filterTags.condition,
            "and_for_objects": this.filterObject.condition,
            "date_from": this.dateFrom,
            "date_to": this.dateTo,
            "persons": this.filterObject.listID.persons,
            "locations": this.filterObject.listID.locations,
            "organisations": this.filterObject.listID.organisations,
            "use_sem_search": this.useSemSearch,
            "political_affiliation": this.filterPoliticalAffiliation.value
          },
          {
            signal: controller.signal,
          });
    },

    // Универсальный метод обновления карточки
    async updateCard(cardId, updates) {
      const url = process.env.VUE_APP_BASE_API + `cards/${cardId}`;
      try {
        await axios.patch(url, updates, {
          headers: {
            "accept": "application/json",
            "Content-Type": "application/merge-patch+json"
          }
        });
        return true;
      } catch (err) {
        this.setError(err);
        return false;
      }
    },

    // Добавление новости в избранное
    async setFavorite(cardId, isFavorite) {
      const success = await this.updateCard(cardId, { is_favourite: isFavorite });
      if (success) {
        this.items.forEach(item => {
          if (item.id === cardId) {
            item.is_favourite = isFavorite;
          }
        });
      }
    },

    async getFavorite() {
      if (controller) {
        controller.abort();
        this.loading = true;
      }

      controller = new AbortController();
      this.items = [];
      this.loading = true;
      this.currentNews = null;

      this.offset = this.currentPage * this.take;
      const LKstore = useLK();
      const url = process.env.VUE_APP_BASE_API + `cards/favorite?offset=${this.offset}&take=${this.take > 0 ? this.take : 20}`;
      return axios.post(url, {
        "q": this.searchValue,
        "project_id": LKstore.project.id,
        "categories": this.filterCategories.filterList,
        "cities": this.filterRegion.filterList,
        "and_for_cities": this.filterRegion.condition,
        "importance": this.filterImportance.list,
        "sentiments": this.filterSentiment.list,
        "tags": this.filterTags.listID,
        "and_for_tags": this.filterTags.condition,
        "date_from": this.dateFrom,
        "date_to": this.dateTo,
        "persons": this.filterObject.listID.persons,
        "locations": this.filterObject.listID.locations,
        "organisations": this.filterObject.listID.organisations,
        "use_sem_search": this.useSemSearch
      }, {
        signal: controller.signal,
      }).then(res => {
        this.totalCount = res.data.total_count;
        this.items = res.data.cards;
        this.currentNews = this.items[0];
        this.loading = false;
        if (!res.data.cards.length) {
          this.emptyNews = true;
        }
      }).catch(err => {
        this.setError(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    // Обновляет города в карточке.
    async setCityCard(cardId, cityList) {
      let url = process.env.VUE_APP_BASE_API + `cards/${cardId}/cities`;
      try {
        await axios.patch(url, cityList);
      } catch (error) {
        console.log(error);
      }
    },

    async facetSearch(string) {
      if (this.searchValue) {
        await this.getRubricNews();

        const escapedString = string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(escapedString, "gi");

        this.items.forEach(item => {
          item.text = item.text.replace(regex, `<span class='marked-word'>${string}</span>`);
          item.raw_text = item.raw_text.replace(regex, `<span class='marked-word'>${string}</span>`);
          item.title = item.title.replace(regex, `<span class='marked-word'>${string}</span>`);
        });
      } else {
        await this.getRubricNews();
      }
    },

    async deleteCard(cardId) {
      const LKStore = useLK();

      try {
        const currentCard = this.items.find((item) => item.id === cardId);
        if (currentCard) {
          this.items.splice(this.items.indexOf(currentCard), 1);
        }
        await axios.delete(process.env.VUE_APP_BASE_API + `projects/${LKStore.project.id}/cards/${cardId}`);
      } catch (e) {
        console.log(e);
      }
    },

    // Изменение сантимента новости
    async changeSentiment(cardId, sentimentValue) {
      await this.updateCard(cardId, { sentiment: sentimentValue });
    },

    // Изменение значимости новости
    async changeImportance(cardId, importanceValue) {
      await this.updateCard(cardId, { importance: importanceValue });
    },

    // Обновление рубрик карточки
    async updateCardRubrics(cardId, rubricsIds) {
      try {
        const notificationsStore = useNotificationsStore();
        await axios.patch(process.env.VUE_APP_BASE_API + `cards/${cardId}/rubrics/`, rubricsIds);
        this.currentNews.rubric_ids = rubricsIds;
        notificationsStore.createNotify(t("toast.changes_saved"), "success");
      } catch (e) {
        console.log(e);
      }
    },

    // Обновление тегов карточки
    async updateCardTags(cardId, tagsIds) {
      try {
        const notificationsStore = useNotificationsStore();
        await axios.patch(process.env.VUE_APP_BASE_API + `cards/${cardId}/tags`, tagsIds);
        this.currentNews.source_tag_ids = tagsIds;
        notificationsStore.createNotify(t("toast.changes_saved"), "success");
      } catch (e) {
        console.log(e);
      }
    },

    // Обновление категории карточки
    async updateCardCategory(cardId, categoryId) {
      const success = await this.updateCard(cardId, { category_id: categoryId });
      if (success) {
        const notificationsStore = useNotificationsStore();
        this.currentNews.category_id = categoryId;
        notificationsStore.createNotify(t("toast.changes_saved"), "success");
      }
    },
    async filesDownload(cardIdList) {
      let url = process.env.VUE_APP_BASE_API + "Files/report";
      const files = await axios.post(url, {
        "projectId": useLK().project.id,
        "cardIDs": cardIdList
      }, {responseType: "blob"});

      const fileUrl = window.URL.createObjectURL(files.data);
      const a = document.createElement("a");
      a.href = fileUrl;
      let filename = files.headers.get("content-disposition");
      filename = filename.match(/(?<=")(?:\\.|[^"\\])*(?=")/)[0];
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(fileUrl);
    },

    // Добавление/Удаление объекта в список фасета.
    // true - Добавлен. false - Удален.
    async toggleObjectInFilter(objectId, objectType) {
      // Проверяем, есть ли уже этот объект в фильтре
      if (this.filterObject.list.some(obj => obj === objectId)) {
        // Если есть, удаляем его
        this.filterObject.list = this.filterObject.list.filter(obj => obj !== objectId);
        this.filterObject.listID[objectType] = this.filterObject.listID[objectType]
            .filter(id => id !== objectId);
        return false;
      } else {
        // Если нет, добавляем
        this.filterObject.list.push(objectId);
        this.filterObject.listID[objectType].push(objectId);
        return true;
      }
    }
  },
});
//
